/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

const PREFIX = 'HomeGrouping';

const classes = {
  header: `${PREFIX}-header`,
  headerTitle: `${PREFIX}-headerTitle`,
  searchInput: `${PREFIX}-searchInput`,
  addButton: `${PREFIX}-addButton`,
  addButtonIcon: `${PREFIX}-addButtonIcon`,
  addButtonDisabled: `${PREFIX}-addButtonDisabled`,
  controlPanel: `${PREFIX}-controlPanel`,
  projectGroups: `${PREFIX}-projectGroups`,
  loader: `${PREFIX}-loader`,
};

const Root = styled(Box)(({theme}) => ({
  [`& .${classes.header}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(8),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(2),
    },
  },
  [`& .${classes.headerTitle}`]: {
    color: theme.palette.text.primary,
    fontWeight: 700,
    fontSize: 28,
    lineHeight: '30px',
  },

  [`& .${classes.searchInput}`]: {
    width: '100%',
    '& fieldset': {
      borderColor: '#202020',
    },
    '& .MuiInputBase-input': {
      padding: theme.spacing(0, 3.5, 0, 0),
      height: '48px',
    },
  },

  [`& .${classes.addButton}`]: {
    minWidth: 'auto',
    height: '48px',
    flexShrink: 0,
    fontSize: '14px',
    fontWeight: 400,
    boxShadow: 'none',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  [`& .${classes.addButtonIcon}`]: {
    fontSize: '18px',
  },
  [`& .${classes.addButtonDisabled}`]: {
    '&:disabled': {
      backgroundColor: theme.palette.figma_gray_dark_2?.main,
      color: theme.palette.figma_gray_middle_dark?.main,
    },
  },

  [`& .${classes.controlPanel}`]: {
    display: 'flex',
    gap: theme.spacing(4),
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
  },

  [`& .${classes.projectGroups}`]: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(16),
    margin: theme.spacing(10, 0, 46, 0),
    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(8),
    },
  },

  [`& .${classes.loader}`]: {
    width: '100%',
    marginTop: theme.spacing(10),
  },
}));

export {classes as HomeGroupingClasses, Root as HomeGroupingRoot};
